import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const LoginTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    {
      id: 'email',
      label: 'Email Login',
      icon: 'Mail',
      description: 'Staff & Academy Access'
    },
    {
      id: 'code',
      label: 'Student Code',
      icon: 'QrCode',
      description: 'Student Portal Access'
    }
  ];

  return (
    <div className="w-full max-w-md mb-8">
      <div className="flex bg-muted rounded-lg p-1">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className={`
              flex-1 flex flex-col items-center space-y-1 p-3 rounded-md transition-all duration-150 ease-out
              ${activeTab === tab?.id
                ? 'bg-card text-foreground elevation-card transform scale-98'
                : 'text-muted-foreground hover:text-foreground hover:transform hover:scale-98'
              }
            `}
          >
            <Icon 
              name={tab?.icon} 
              size={20} 
              color={activeTab === tab?.id ? 'currentColor' : '#6B7280'} 
            />
            <span className="font-medium text-sm">{tab?.label}</span>
            <span className="text-xs opacity-70">{tab?.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LoginTabs;